// S4 kit items (sleeves / deck box / playmat / toploaders / binders). In-stock only; themed only when they match the deck.
// Operator note #4: product photos are shown whole (object-fit: contain) in one uniform light square frame, from a
// high-res Shopify CDN size with a 2x srcset; cards are horizontal (photo left, text right) so any count fills
// balanced rows. Q28: a deck "kit" is only ever sleeves + deck box (+ playmat); graded/PSA sleeves, toploaders,
// semi-rigids and binders are card protection, never a deck kit.
import { html } from './singles-hub--core--html.js?v=c7c57de095';
import { cart } from './singles-hub--cart.js?v=c7c57de095';
import { money, pretty } from './singles-hub--format.js?v=c7c57de095';
import { productImg } from './singles-hub--components--ui.js?v=c7c57de095';
import { toast } from './singles-hub--components--host.js?v=c7c57de095';

const PROTECTION = /graded|psa|resealable|semi.?rigid|toploader|slab|one.?touch/i;
export const isDeckItem = (it) => ['sleeves', 'deck_box', 'playmat'].includes(it.kind) && !PROTECTION.test(it.title || '');
// Items that belong with a deck (sleeves, deck boxes, playmats); themed items only when the engine matched them.
export const deckItems = (kit) => ((kit && kit.items) || []).filter((it) => (it.deck_kit != null ? !!it.deck_kit : isDeckItem(it)));
// A proper kit = sleeves + deck box (+ playmat when in stock), cheapest of each. null when we can't make one.
export function properKit(kit) {
  if (kit && kit.kit_complete != null) {
    if (!kit.kit_complete) return null;
    const ids = (kit.default_kit || []).map(String);
    const picked = ((kit && kit.items) || []).filter((i) => ids.includes(String(i.variant_id)));
    return picked.length ? picked : null;
  }
  const items = deckItems(kit);
  const best = (k) => items.filter((i) => i.kind === k).sort((a, b) => a.price - b.price)[0];
  const sl = best('sleeves'), db = best('deck_box'), pm = best('playmat');
  if (!sl || !db) return null;
  return [sl, db].concat(pm ? [pm] : []);
}
export function kitNote(kit) {
  if (!kit) return '';
  if (properKit(kit)) return '';
  return kit.kit_complete === false && kit.note ? kit.note : 'Plain sleeves and deck boxes coming soon. We only show themed sleeves when they match your deck.';
}

function cols(n, max) {
  for (let c = Math.min(max, n); c >= 2; c--) if (n % c === 0) return c;
  return Math.min(max, n);
}

export function kitView(items, { inCart = {}, w = 1200, action = 'kitAdd' } = {}) {
  if (!items || !items.length) return '';
  const btn = (it) => inCart[it.variant_id]
    ? html`<button type="button" class="mcc-btn mcc-btn--ok mcc-btn--sm" disabled aria-disabled="true">In basket ✓</button>`
    : html`<button type="button" class="mcc-btn mcc-btn--sm" data-click="${action}" data-v="${it.variant_id}" data-t="${it.title}">Add</button>`;
  const max = w >= 990 ? 3 : w >= 600 ? 2 : 1;
  return html`<div class="mcc-grid mcc-kits" style="--cols:${cols(items.length, max)}">${items.map((it) => html`<div class="mcc-kit" data-key="k${it.variant_id}">
    ${productImg(it.image_url, { alt: pretty(it.title), w: 300 })}
    <div class="mcc-kit__body"><b class="mcc-small mcc-kit__t">${pretty(it.title)}</b><span class="mcc-xs mcc-muted">${it.sub}</span>
      <div class="mcc-kit__foot"><b class="mcc-num">${money(it.price)}</b>${btn(it)}</div></div></div>`)}</div>`;
}

export async function addKitItem(variantId, title) {
  try {
    const r = await cart.addItems([{ variant_id: variantId, qty: 1 }]);
    if (r.added.length) toast(`Added ${pretty(title)}.`, 'ok'); else toast(`${pretty(title)} is already in your basket or just sold out.`, 'stock');
    return r;
  } catch (e) { toast('We couldn’t add that to your basket. Please try again.', 'error'); return null; }
}
